import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { fetchRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';

export default function fetchArticleContent(experience, faqid) {
  return (dispatch, getState) => {
    const { topicList } = getState();
    if (topicList && topicList.topics && topicList.topics.length <= 0) {
      dispatch(fetchTopicTree(experience));
      dispatch(fetchArticle(faqid))
        .then((response) => {
          if (response && response.payload) {
            dispatch(updateBreadCrumbFromArticleContent(response.payload));
            dispatch(fetchRelatedArticle(response.payload.articleTitle));
            dispatch(getCommunityResults(response.payload.articleTitle));
          }
        });
    } else {
      dispatch(fetchArticle(faqid))
        .then((response) => {
          if (response && response.payload) {
            dispatch(updateBreadCrumbFromArticleContent(response.payload));
            dispatch(fetchRelatedArticle(response.payload.articleTitle));
            dispatch(getCommunityResults(response.payload.articleTitle));
          }
        });
    }
  };
}



// WEBPACK FOOTER //
// ./home/actions/action-article-content.js